import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * ScrollToTop component ensures that the window scrolls back to the top
 * whenever the route changes. This is standard behavior for SPAs to
 * mimic multi-page application navigation.
 */
export const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    // Standard scroll to top
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
};
